import { ADD_CART,  REMOVE_CART, CHANGE_CART_NAME, SELECT_CART, ADD_ITEM_TO_CART, REMOVE_ITEM_FROM_CART, UPDATE_CART_ITEM, COPY_CART, CHANGE_FLOAT_CART_STATE, MANAGE_FAVORITES, FILTER, SORT, ADD_SORT_TAG, RESET_SORT } from './actionTypes';

const initialState = {
    bags: [],
    activeBag: null,
    favorites: [],
    floatCartState: false,
    filter: null,
    sort: {
        "availables": [],
        "selected": [],
    }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_CART:
        let bag = {
            "id": state.bags.length > 0 ? state.bags[state.bags.length - 1]["id"] + 1 : 0,
            "name": "bag",
            "items": []
        };

        state["bags"] = [...state.bags, bag];
        state.activeBag = state.bags[state.bags.length - 1].id;

        return {
            ...state,
            bags: state.bags,
            activeBag: state.activeBag
        };

    case REMOVE_CART:
        let isActiveBagDeleted = false;
        if( state.activeBag === action.payload.id ){
            isActiveBagDeleted = true;
        }

        state.bags = state.bags.filter(bag => {
            if( bag.id !== action.payload.id ){
                if( isActiveBagDeleted ){
                    state.activeBag = bag.id;
                    isActiveBagDeleted = false;
                }
                return bag;
            }
        })

        if( state.bags.length === 0 ){
            state.activeBag = null
        }

        return {
            ...state,
            bags: state.bags,
            activeBag: state.activeBag
        };

    case CHANGE_CART_NAME:
        if( action.payload.name !== "" && action.payload.null !== null ){
            state["bags"] = state.bags.map(item => {
                if( item.id === action.payload.id ){
                    item["name"] = action.payload.name;
                    return item;
                }
                return item;
            });
        }
        return {
            ...state,
            bags: state.bags
        };

    case ADD_ITEM_TO_CART:
        if( state.bags.length > 0 ){
            state.bags = state.bags.filter(bag => {
                if( bag.id === state.activeBag ){
                    let isExist = false;
                    bag.items.filter(item => {
                        if( item.id === action.payload.item.id ){
                            isExist = true;
                            item.quantity += 1;
                        }
                        return item;
                    });
    
                    if( !isExist ){
                        bag.items = [...bag.items, action.payload.item];
                        bag.items[bag.items.length - 1].quantity = 1;
                    }
                }
    
                return bag;
            });
        }
        else{
            action.payload.item.quantity = 1;
            state.bags = [{
                "id": 0,
                "name": "bag",
                "items": [action.payload.item]
            }];

            state.activeBag = 0;
        }

        return {
            ...state,
            bags: state.bags,
            activeBag: state.activeBag
        }

    case REMOVE_ITEM_FROM_CART:

        return {
            ...state,
            bags: state["bags"].filter(bag => {
                if( bag.id === action.payload.bagId ){
                    bag["items"] = bag["items"].filter(item => {
                        if( item.id !== action.payload.item.id ){
                            return item;
                        }
                    });
                    return bag.items;
                }
                return bag;
            })
        }

    case UPDATE_CART_ITEM:
        state["bags"] = state.bags.filter(bag => {
            if( bag.id === action.payload.bagId ){
                bag["items"] = bag.items.filter(item => {
                    if( item.id === action.payload.item.id ){
                        if( action.payload.action === "minus" ){
                            item["quantity"] = item["quantity"] - 1;
                        }
                        else{
                            item["quantity"] = item["quantity"] + 1;
                        }
                    }

                    if( item["quantity"] > 0 ){
                        return item;
                    }
                });
            }
            return bag;
        });

        return {
            ...state,
            bags: state.bags
        }

    case SELECT_CART:
        state["activeBag"] = action.payload.id;
        return {
            ...state,
            activeBag: state.activeBag
        }

    case COPY_CART:
        let copy_bag = {};
        state.bags.forEach(bag => {
            if( bag.id === action.payload.bagId ){
                copy_bag = Object.assign(copy_bag, bag);
                copy_bag.id = state.bags[state.bags.length - 1]["id"] + 1
                copy_bag.name = "Copy "+copy_bag.name;
                if( typeof copy_bag.default !== "undefined" ){
                    delete copy_bag.default;
                }
            }
        });
        return {
            ...state,
            bags: [...state.bags, copy_bag]
        }

    case MANAGE_FAVORITES:
        let isFavorite = state.favorites.map(item => item.id).includes(action.payload.item.id);

        if( !isFavorite ){
            state.favorites = [...state.favorites, action.payload.item];
            console.log(state.favorites);
        }
        else{
            state.favorites = state.favorites.filter(item => {
                if( item.id !== action.payload.item.id ){
                    return item;
                }
            });
        }

        return {
            ...state,
            favorites: state.favorites
        }

    case CHANGE_FLOAT_CART_STATE:
        return {
            ...state,
            floatCartState: !state.floatCartState
        }

    case FILTER:
        return {
            ...state,
            filter: action.payload.type
        }

    case SORT:
        let sort = state.sort;
        if( sort.selected.includes(action.payload.type) ){
            if( sort.selected.length > 0 )
            {
                sort.selected = sort.selected.filter(tag => {
                    if( tag !== action.payload.type ){
                        return tag;
                    }
                });
            }
        }
        else{
            sort.selected = [...sort.selected, action.payload.type];
        }

        state.sort = sort;

        return {
            ...state,
            sort: state.sort
        }

    case ADD_SORT_TAG:
        state.sort.availables = [...state.sort.availables, action.payload.tag];
        return {
            ...state,
            sort: state.sort
        }

    case RESET_SORT:
        state.sort.availables = initialState.sort.availables;
        return {
            ...state,
            sort: state.sort
        }

    default:
      return state;
  }
}
